(function () {
  if (customElements.get('cogi-bundle-picker')) return;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function norm(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }

  class CogiBundlePicker extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.formId = this.dataset.form;
      this.d2 = parseFloat(this.dataset.d2) || 0;
      this.d3 = parseFloat(this.dataset.d3) || 0;
      this.currency = this.dataset.currency || 'USD';
      this.eachLabel = this.dataset.each || 'each';
      this.saveLabel = this.dataset.save || 'Save';
      this.lastId = null;
      this.seeded = false;
      this.skipSyncUntil = 0;

      var data = {};
      try { data = JSON.parse(this.querySelector('.cbp__data').textContent); } catch (e) { data = {}; }
      this.variants = data.variants || [];
      this.options = data.options || [];

      this.fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: this.currency
      });

      this.wraps = [].slice.call(this.querySelectorAll('.cbp__tier-wrap'));

      this.buildRows();
      this.seedRows();

      // Every tier renders one selector row per unit, so the theme's own variant picker would be
      // a duplicate control. Hidden from JS (not CSS) on purpose: if this script fails to run,
      // the picker stays visible and the product stays buyable.
      var vp = document.querySelector('.product-info__variant-picker');
      if (vp) vp.classList.add('cbp-owns-variants');

      this.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;
        if (t.classList.contains('cbp__radio')) { self.setQty(); self.render(); return; }
        if (t.classList.contains('cbp__sel')) {
          var row = t.closest('.cbp__row');
          if (row && row.dataset.unit === '1') {
            // Give the theme picker time to settle before the poll re-reads it, otherwise
            // syncRow1 clobbers the shopper's choice mid-update.
            self.skipSyncUntil = Date.now() + 1500;
            self.pushRowToTheme(row);
          }
          self.render();
        }
      });

      this.bindForms();
      this.poll = setInterval(function () { self.sync(); }, 300);
      this.sync();
      this.setQty();
      this.render();
    }

    disconnectedCallback() { if (this.poll) clearInterval(this.poll); }

    variantId() {
      var el = document.querySelector('input[name="id"][form="' + this.formId + '"]')
        || document.querySelector('.product-variant-id')
        || document.querySelector('input[name="id"]');
      return el ? String(el.value) : '';
    }

    byId(id) {
      for (var i = 0; i < this.variants.length; i++) {
        if (String(this.variants[i].id) === String(id)) return this.variants[i];
      }
      return null;
    }

    byOptions(vals) {
      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i], ok = true;
        for (var j = 0; j < vals.length; j++) { if (v.o[j] !== vals[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    buildRows() {
      var self = this;
      this.wraps.forEach(function (wrap) {
        var qty = parseInt(wrap.dataset.qty, 10);
        var host = wrap.querySelector('[data-cbp-rows]');
        if (!host) return;
        var html = '';
        for (var u = 1; u <= qty; u++) {
          html += '<div class="cbp__row" data-unit="' + u + '">';
          html += '<span class="cbp__rownum">#' + u + '</span><div class="cbp__sels">';
          html += self.options.map(function (opt, i) {
            return '<select class="cbp__sel" data-opt="' + i + '" aria-label="' + esc(opt.name) + ' for console ' + u + '">' +
              opt.values.map(function (val) {
                return '<option value="' + esc(val) + '">' + esc(val) + '</option>';
              }).join('') + '</select>';
          }).join('');
          html += '</div></div>';
        }
        host.innerHTML = html;
      });
    }

    seedRows() {
      if (this.seeded) return;
      var v = this.byId(this.variantId()) || this.variants[0];
      if (!v) return;
      this.querySelectorAll('.cbp__row').forEach(function (row) {
        row.querySelectorAll('.cbp__sel').forEach(function (sel) {
          var i = parseInt(sel.dataset.opt, 10);
          if (v.o[i] != null) sel.value = v.o[i];
        });
      });
      this.seeded = true;
    }

    syncRow1() {
      var v = this.byId(this.variantId());
      if (!v) return;
      this.querySelectorAll('.cbp__row[data-unit="1"]').forEach(function (row) {
        row.querySelectorAll('.cbp__sel').forEach(function (sel) {
          var i = parseInt(sel.dataset.opt, 10);
          if (v.o[i] != null && sel.value !== v.o[i]) sel.value = v.o[i];
        });
      });
    }

    pushRowToTheme(row) {
      var self = this;
      var vals = [];
      row.querySelectorAll('.cbp__sel').forEach(function (sel) {
        vals[parseInt(sel.dataset.opt, 10)] = sel.value;
      });
      vals.forEach(function (val, i) { self.setThemeOption(i, val); });
    }

    setThemeOption(index, value) {
      var scope = document.querySelector('.product-info__variant-picker');
      if (!scope) return false;
      var name = 'option' + (index + 1);
      var want = norm(value);

      // 1. Radio inputs (how the theme renders colour).
      var radios = scope.querySelectorAll('input[type="radio"][name="' + name + '"]');
      for (var i = 0; i < radios.length; i++) {
        if (norm(radios[i].value) === want) {
          if (!radios[i].checked) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
      }

      // 2. A real <select>, if the theme is set to dropdown mode.
      var selects = scope.querySelectorAll('select');
      for (var s = 0; s < selects.length; s++) {
        var opts = selects[s].options;
        for (var o = 0; o < opts.length; o++) {
          if (norm(opts[o].value) === want || norm(opts[o].textContent) === want) {
            if (selects[s].value !== opts[o].value) {
              selects[s].value = opts[o].value;
              selects[s].dispatchEvent(new Event('change', { bubbles: true }));
            }
            return true;
          }
        }
      }

      // 3. Custom listbox (how the theme renders storage): click the matching option.
      //    Match on normalised text — these buttons carry extra whitespace and marker markup,
      //    so a strict equality check against textContent fails.
      var nodes = scope.querySelectorAll('button, [role="option"], variant-option-value');
      for (var n = 0; n < nodes.length; n++) {
        var txt = norm(nodes[n].textContent);
        if (txt === want || txt.indexOf(want) === 0) { nodes[n].click(); return true; }
      }

      // 4. Last resort: write the hidden input directly.
      var hidden = scope.querySelector('[name="' + name + '"]');
      if (hidden) {
        hidden.value = value;
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      return false;
    }

    rowVariant(row) {
      var vals = [];
      row.querySelectorAll('.cbp__sel').forEach(function (sel) {
        vals[parseInt(sel.dataset.opt, 10)] = sel.value;
      });
      return this.byOptions(vals);
    }

    selectedWrap() {
      for (var i = 0; i < this.wraps.length; i++) {
        var r = this.wraps[i].querySelector('.cbp__radio');
        if (r && r.checked) return this.wraps[i];
      }
      return this.wraps[0];
    }

    selectedQty() {
      var w = this.selectedWrap();
      return w ? parseInt(w.dataset.qty, 10) : 1;
    }

    pct(q) { return q >= 3 ? this.d3 : (q >= 2 ? this.d2 : 0); }
    money(c) { return this.fmt.format(c / 100); }

    sync() {
      var id = this.variantId();
      if (id === this.lastId) return;
      this.lastId = id;
      if (Date.now() < this.skipSyncUntil) { this.render(); return; }
      this.syncRow1();
      this.render();
    }

    render() {
      var self = this;
      var fallback = this.byId(this.variantId()) || this.variants[0];
      if (!fallback) return;

      this.wraps.forEach(function (wrap) {
        var qty = parseInt(wrap.dataset.qty, 10);
        var rows = wrap.querySelectorAll('.cbp__row');
        var gross = 0;
        rows.forEach(function (row) {
          var rv = self.rowVariant(row);
          gross += rv ? rv.p : fallback.p;
        });
        if (!rows.length) gross = fallback.p * qty;

        var pct = self.pct(qty);
        var total = Math.round(gross * (100 - pct) / 100);
        var saved = gross - total;

        var t = wrap.querySelector('[data-cbp-total]');
        var w = wrap.querySelector('[data-cbp-was]');
        var u = wrap.querySelector('[data-cbp-unit]');
        var s = wrap.querySelector('[data-cbp-save]');

        if (t) t.textContent = self.money(total);
        if (w) {
          if (saved > 0) { w.textContent = self.money(gross); w.hidden = false; }
          else { w.textContent = ''; w.hidden = true; }
        }
        if (u) u.textContent = self.money(Math.round(total / qty)) + ' ' + self.eachLabel;
        if (s) {
          s.textContent = saved > 0 ? self.saveLabel + ' ' + self.money(saved) : '';
          s.style.display = saved > 0 ? '' : 'none';
        }
      });
    }

    setQty() {
      document.querySelectorAll('input[name="quantity"]').forEach(function (i) { i.value = 1; });
    }

    bindForms() {
      var self = this;
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
        if (f.__cbpBound) return;
        f.__cbpBound = true;
        // Intercept EVERY tier, including a single unit. The cart is always built from the
        // rows, so it can never disagree with the prices shown — even if pushing a selection
        // back into the theme's hidden picker did not take.
        f.addEventListener('submit', function (e) {
          if (!self.selectedWrap()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          self.addBundle(f);
        }, true);
      });
    }

    addBundle(form) {
      var self = this;
      var counts = {};
      var add = function (id) { if (!id) return; counts[id] = (counts[id] || 0) + 1; };

      this.selectedWrap().querySelectorAll('.cbp__row').forEach(function (row) {
        var rv = self.rowVariant(row);
        add(rv ? rv.id : self.variantId());
      });

      var items = Object.keys(counts).map(function (k) {
        return { id: parseInt(k, 10), quantity: counts[k] };
      });
      if (!items.length) return;

      var btn = form ? form.querySelector('[type="submit"]') : null;
      if (btn) btn.setAttribute('disabled', '');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        window.location.href = '/cart';
      }).catch(function () {
        if (btn) btn.removeAttribute('disabled');
        window.alert('Sorry, we could not add that bundle. Please try again.');
      });
    }
  }

  customElements.define('cogi-bundle-picker', CogiBundlePicker);
})();
